const MOBILE_VIEW_BREAKPOINT = 768

export const isMobile = () => document.documentElement.clientWidth < MOBILE_VIEW_BREAKPOINT
